// src/pages/Dashboard/components/DashboardStats.js

import React from "react";
import {
  FaUsers,
  FaDollarSign,
  FaMapMarkerAlt,
  FaChartLine,
} from "react-icons/fa";

// Co-locating StatCard here as it's only used in this context
const StatCard = ({ icon: Icon, title, value, loading, subtitle }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 p-6 group">
    <div className="flex items-start justify-between mb-4">
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-white shadow-sm">
          <Icon className="text-xl" />
        </div>
        <div>
          <h3 className="text-sm font-medium text-gray-600 mb-1">{title}</h3>
          <p className="text-2xl font-bold text-gray-900">
            {loading ? (
              <div className="animate-pulse bg-gray-200 h-8 w-20 rounded"></div>
            ) : (
              value
            )}
          </p>
          {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
        </div>
      </div>
    </div>
  </div>
);

const DashboardStats = ({
  locationsCount,
  thisMonthRevenue,
  totalServicesToday,
  todayRevenue,
  loading,
  transactionsLoading,
}) => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatCard
        icon={FaMapMarkerAlt}
        title="Total Locations"
        value={locationsCount || 0}
        loading={loading}
        subtitle="Active stores"
      />
      <StatCard
        icon={FaDollarSign}
        title="Total Revenue"
        value={`$${(thisMonthRevenue || 0).toLocaleString()}`}
        loading={transactionsLoading}
        subtitle="This month"
      />
      <StatCard
        icon={FaChartLine}
        title="Services Today"
        value={totalServicesToday || 0}
        loading={transactionsLoading}
        subtitle="Completed"
      />
      <StatCard
        icon={FaDollarSign}
        title="Today's Revenue"
        value={`$${(todayRevenue || 0).toLocaleString()}`}
        loading={transactionsLoading}
        subtitle="Today"
      />
    </section>
  );
};

export default DashboardStats;